<ion-content class="container">
  <div class="tabs-container">

    <div class="card fade-in">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">

            <mat-tab-group #tabGroup class="pt-10 pr-10 animated-tabs" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)" animationDuration="400ms">

              <!-- Dashboard Tab -->
              <mat-tab label="Dashboard">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">speed</span>Dashboard
                  </span>
                </ng-template>
              </mat-tab>

              <!-- Employee Tab -->
              <mat-tab label="Employee Admin"
                *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">person</span>My Reimbursement
                  </span>
                </ng-template>
              </mat-tab>

              <!-- Manager Tab -->
              <mat-tab label="Manager"
                *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' || loggedInUserRole == 'Employee' || approveMatrix=='EMPLOYEE_TO_FINANCE' || isHODLoginCheck)">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">ads_click</span>Team Reimbursement
                  </span>
                </ng-template>
              </mat-tab>


              <!-- Finance Tab -->
              <mat-tab label="Finance" *ngIf="(isFinanceLoginUser || loggedInUserRole == 'HR Admin')">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">ads_click</span>Reimbursement Approve
                  </span>
                </ng-template>
              </mat-tab>


              <!-- HR Admin Tab -->
              <mat-tab label="HrAdmin"
                *ngIf="approveMatrix === 'EMPLOYEE_TO_MANAGER_TO_HR_TO_FINANCE' 
         && !(loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' || loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD' || isHODLoginCheck)">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">person</span>HR Approval
                  </span>
                </ng-template>
              </mat-tab>


              <!-- Reports Tab -->
              <mat-tab label="Reports">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">description</span>Reports
                  </span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
        <!-- Right Side Buttons -->
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10"
          *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && !mobileResponsiveService.hideForTabletAndBelow">

          <div class="center-content float-right fade-in-right">
            <div>
              <span class="cp fs-14 fs_12ForMobile link font_regular center-content mr-20 logs-link"
                (click)="onClickLogs('Logs')">
                <img src="././assets/icon/logsIcon.svg"><u>Logs</u>
              </span>
            </div>
            <div>
              <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5 setup-btn"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup
              </button>
            </div>
          </div>
        </ion-col>

      </ion-row>

    </div>



    <!---Setup Popup --->
    <div class="modal fade" [style.display]="showSetupPopup ? 'block' : 'none'"
      *ngIf="!mobileResponsiveService.hideForTabletAndBelow">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
            <img (click)="onClickBreadcrumExpence()" src="././assets/icon/backArrow.svg" class="cp">
            <label class="font_semibold fs-18 fs_16ForMobile ml-10 mt-5 black_color">
              <span class="cp" (click)="onClickBreadcrumExpence()">Expense</span> /
              <span [style.color]="buttonColorName">Setup</span>
            </label>
          </div>
          <div class="modal-body p-20">
            <div class="mt-10">
              <div class="cardBox card" style="background-color: white; padding: 10px;">
                <ion-row>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Fiscal Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="inputBoxDisabled">
                      {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                    </div>
                  </ion-col>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                        (selectionChange)="getYearSetupForReimbursement()">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{sharedService.transformYearToFyFormat(item.year)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>

                </ion-row>
                <ion-row class="d-flex">
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Approval Matrix?<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field appearance="outline" class="w-100  mat-height40" style=" margin-top: 10px;">
                      <mat-label class="centered-label">Select Approval Matrix</mat-label>
                      <mat-select [(ngModel)]="approveMatrix" name="approvalMatrixSelect"
                        [disabled]="isLimitTypeLocked">
                        <mat-option value="EMPLOYEE_TO_MANAGER_TO_FINANCE">
                          Employee To Manager To Finance
                        </mat-option>
                        <mat-option value="EMPLOYEE_TO_FINANCE">
                          Employee To Finance
                        </mat-option>
                        <mat-option value="EMPLOYEE_TO_MANAGER_TO_HR_TO_FINANCE">
                          Employee To Manager To HR Admin To Finance
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>


                  <!-- Finance Admin Section -->

                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Finance Admin<span class="red-cl">&nbsp;*</span>

                    </div>
                    <mat-form-field appearance="outline" class="w-100 mw-sm-250 mat-height40" style="margin-top: 10px">
                      <mat-label class="centered-label">Select Finance Admin</mat-label>
                      <mat-select [(ngModel)]="selectedEmployee" name="reimbursementSelect" multiple>
                        <mat-option *ngFor="let item of getAllFinanceUserDD" [value]="item.id"
                          (click)="confirmSelection(item, $event)"
                          [disabled]="allreadySellectedFinanceAdmin.includes(item.id) && reimbursementTable.length>0 ">
                          {{ item.firstName }} {{ item.lastName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ion-row>


                <ion-row>
                  <ion-col size="12" class="mt-10">
                    <div class="font_semibold fs-16 fs_14ForMobile mb-5">
                      Reimbursement Type <span class="red-cl">&nbsp;*</span>
                    </div>
                  </ion-col>
                  <ion-col size="12" *ngIf="!isReimbursementType">
                    <div class="font_semibold addnewbtn fs-14 fs_12ForMobile cp" (click)="toggleInputs()">
                      + Add New
                    </div>
                  </ion-col>


                  <ion-row *ngIf="showInputs" class="mb-10">
                    <ion-col size="12">
                      <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                        <input matInput [(ngModel)]="reimbursementAdd" type="text" placeholder="Reimbursement Type"
                          class="font_regular fs-12" min="1" 
                          [attr.disabled]="restrictToEditSetup ? true : null"  maxlength="255" (keyup)="checkMaxLength(reimbursementAdd)" (keypress)="preventNegative($event)"
                          (input)="validateInput($event)" />
                      </mat-form-field>


                    </ion-col>

                  </ion-row>
                  <ion-col size="12" *ngIf="showInputs">
                    <ion-row>
                      <ion-col size="auto">
                        <div class="font_semibold addnewbtn fs-14 fs_12ForMobile cp"
                          [ngClass]="{ 'disabled': !reimbursementAdd }" (click)="!reimbursementAdd || saveData()">
                          Save
                        </div>

                      </ion-col>
                      <ion-col size="auto">
                        <div class="font_semibold addnewbtn ml-10 fs-14 fs_12ForMobile cp bluecolor"
                          (click)="removeInputs()">
                          Cancel
                        </div>
                      </ion-col>
                    </ion-row>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="mt-10">
                    <div class="table-container">
                      <table class="custom-table rounded-header">
                        <thead>
                          <tr>

                            <th class="font_semibold fs-14 fs_12ForMobile">Reimbursement Type</th>

                            <th class="font_semibold fs-14 fs_12ForMobile text-center">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="reimbursementTable.length === 0">
                            <td colspan="3" class="text-center">No Records</td>
                          </tr>
                          <tr *ngFor="let data of reimbursementTable; let i = index">
                            <td>

                              <span *ngIf="editableIndex !== i || !EditData">{{ data.reimbursementType }}</span>
                              <mat-form-field *ngIf="editableIndex === i && EditData"  class="w-100 mw-sm-250 mat-height40 mat-input-style">
                                <input type="hidden" [(ngModel)]="data.reimbursementId" />
                                <input matInput type="text" min="1" maxlength="255" (keyup)="checkMaxLength(data.reimbursementType)" [(ngModel)]="data.reimbursementType"
                                  placeholder="Edit Reimbursement Type"
                                  (ngModelChange)="updateSpecificreimbursmentType(data)" class="font_regular" />
                              </mat-form-field>
                            </td>

                            <td>

                              <span class="material-icons fs-20 red cp"
                                (click)="deleteReImbursement(data.reimbursementType,i);">delete</span>

                              <span class="material-icons fs-20 blue cp" *ngIf="(editableIndex !== i || !EditData)"
                                (click)="editReImbursement(data, i)" style="margin-left: 5px;">edit</span>
                              <!-- <mat-icon>edit</mat-icon> -->
                              <!-- Close Icon -->
                              <span *ngIf="editableIndex === i && EditData" class="material-icons close p-10 cp fs-20"
                                (click)="closeEditing()">
                                close
                              </span>

                              <!-- Save Icon -->
                              <!-- <span *ngIf="editableIndex === i && EditData" class="material-icons link p-10 cp fs-20"
                                (click)="updateReimbursement()"> -->
                              <span *ngIf="editableIndex === i && EditData" class="material-icons link p-10 cp fs-20"
                                (click)="updateReimbursementType(data.reimbursementId)">
                                check
                              </span>
                            </td>

                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
                <ion-row>


                  <ion-col size="12" class="mt-10" *ngIf="reimbursementTable.length > 0">
                    <div class="font_semibold fs-16 fs_14ForMobile mb-5">
                      Do you want limit?<span class="red-cl">&nbsp;*</span>
                    </div>

                    <mat-radio-group [(ngModel)]="wantLimit" aria-label="Select an option"
                      class="fs-14 fs_12ForMobile font_semibold" [disabled]="isLimitTypeLocked"
                      (change)="onSelectionChangeForWantLimit($event.value)">
                      <mat-radio-button value="yes">
                        Yes
                      </mat-radio-button>
                      <mat-radio-button value="no" class="pl-10">
                        No
                      </mat-radio-button>
                    </mat-radio-group>
                  </ion-col>


                  <ion-col size="12" class="mt-10" *ngIf="wantLimit=='yes'">
                    <div class="font_semibold fs-16 fs_14ForMobile mb-5">
                      How do you want to set limit?<span class="red-cl">&nbsp;*</span>
                    </div>

                    <mat-form-field appearance="outline" class="w-50 mat-height40" style="width:30% ;margin-top: 10px;">
                      <mat-label>Select Limit Type</mat-label>
                      <mat-select [(ngModel)]="limitType" aria-label="Select an option" [disabled]="isLimitTypeLocked"
                        (selectionChange)="onSelectionChangeLimit($event)">
                        <mat-option value="Band">Band</mat-option>
                        <mat-option value="Both">Band&Grade</mat-option>
                        <mat-option value="Location">Location</mat-option>
                        <mat-option value="Neither">Neither</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div *ngIf="isLimitTypeLocked" class="info-text">
                      <small>The limit type is locked and cannot be changed within 1 year of the initial
                        selection.</small>
                    </div>
                  </ion-col>



                </ion-row>
                <div style="width: 30%;">
                  <ion-col size="4" class="mt-10" *ngIf="wantLimit!=='no' && wantLimit!==''">
                    <div class="font_semibold fs-16 fs_14ForMobile mb-5 ">
                      Select Reimbursement<span class="red-cl">&nbsp;*</span>
                    </div>

                    <mat-form-field appearance="outline" class="w-100  mat-height40">
                      <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
                      <mat-label class="centered-label">Select Reimbursement</mat-label>
                      <mat-select class="centered-label" [(ngModel)]="selectedReimbursement" name="reimbursementSelect"
                        (selectionChange)="onSelectionChange($event);onReimbursementIdChange($event.value)">
                        <mat-option *ngFor="let item of reimbursementTable" [value]="item.reimbursementId">

                          {{ item.reimbursementType }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- <div class="card">
        <div class="card-body">
          <div class="p-10">
  
            <div class="setUptable-container table-container">
              <table class="hover mb-5 reimbursmenttable custom-table rounded-header"
                *ngIf="selectedReimbursement!=null && wantLimit!=='no' && wantLimit!=='' && limitType!=''">

                <thead class="bg-gray">
                  <tr>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black" *ngIf="limitType=='Band'||limitType=='Both'">
                      Band</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black" *ngIf="limitType=='Both'">Grade</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black" *ngIf="limitType=='Location'">Location</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black"
                      *ngIf="limitType=='Band'||limitType=='Both'||limitType=='Location'||limitType=='Neither'">Limit
                    </th>
                   
                    <th class="fs-14 fs_12ForMobile font_bold cl-black"></th>
                  </tr>
                </thead>

                <tbody class="bg-white" >
                  <ng-container *ngFor="let item of bandListData; let i = index">
                    <tr *ngFor="let gradeItem of item?.grades; let rowId = index">

             
                      <td *ngIf="rowId === 0" [attr.rowspan]="item?.grades.length">
                        <span>{{ item.band }}</span>
                      </td>

                      <td *ngIf="limitType === 'Grade' || limitType === 'Both'">
                        {{ gradeItem.grade }}
                      </td>

                      <td>
                      
                        <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                          <input [(ngModel)]="gradeItem.limit" type="number"
                            (ngModelChange)="IndividualTotalWeightage(item)" (keydown)="preventNegative($event)"
                            [disabled]="editedIndividualScoreId !== (item.band + '-' + gradeItem.grade) && !isFormDisabled"
                            matInput placeholder="Set Limit" class="font_regular">
                        </mat-form-field>
                      </td>

                      <td>
                        <div class="d-flex">
                          <img (click)="onClickIndividualScoreEdit(item.band + '-' + gradeItem.grade)"
                            *ngIf="editedIndividualScoreId !== (item.band + '-' + gradeItem.grade)"
                            class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">

                          <span (click)="getScoreToFinalConverterIndividual()"
                            *ngIf="editedIndividualScoreId === (item.band + '-' + gradeItem.grade) && onCheckIconView"
                            class="material-icons close p-10 cp fs-20">close</span>

                          <span
                            *ngIf="editedIndividualScoreId === (item.band + '-' + gradeItem.grade) && onCheckIconView"
                            (click)="handleReimbursementClick(gradeItem.limit,item.reimbursementId,item.band + '-' + gradeItem.grade,gradeItem.check)"
                            class="material-icons link p-10 cp fs-20">
                            check
                          </span>
                        </div>
                      </td>
                    </tr>

                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> -->

      <div class="card">
        <div class="card-body">
          <div class="p-10">

            <div class="setUptable-container table-container">
              <table class="hover mb-5 reimbursmenttable custom-table rounded-header"
                *ngIf="selectedReimbursement!=null && wantLimit!=='no' && wantLimit!=='' && limitType!=''&& limitType!=='Both'">

                <thead class="bg-gray">
                  <tr>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black" *ngIf="limitType=='Band'">Band</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black" *ngIf="limitType=='Location'">Location</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black"
                      *ngIf="limitType=='Band' ||limitType=='Location'||limitType=='Neither'">Limit</th>
                    <!-- <th class="fs-14 fs_12ForMobile font_bold cl-black">Total weightage</th> -->
                    <th class="fs-14 fs_12ForMobile font_bold cl-black"></th>
                  </tr>
                </thead>

                <tbody class="bg-white">

                  <tr *ngFor="let item of bandListData ; let rowId = index">

                    <td class="fs-14 fs_12ForMobile font_regular" *ngIf="limitType=='Band'">

                      <span>{{item.band}}</span>
                    </td>

                    <td class="fs-14 fs_12ForMobile font_regular" *ngIf="limitType=='Location'">
                      <span>{{item.location}}</span>
                    </td>
                    <td class="fs-14 fs_12ForMobile font_regular">
                      <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">

                        <input [(ngModel)]="item.reimbursementId" type="hidden"
                          *ngIf="!reimbursementAddId && !reimbursementBandId" placeholder="Set Limit"
                          class="font_regular">
                        <input [(ngModel)]="item.limit" type="number"
                          (ngModelChange)="IndividualTotalWeightage(item,'')" (keydown)="preventNegative($event)"
                          [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled" matInput
                          placeholder="Set  Limit" class="font_regular">
                      </mat-form-field>

                    </td>
                    <td>
                      <div class="d-flex">
                        <img (click)="onClickIndividualScoreEdit1(rowId)" *ngIf="editedIndividualScoreId !== rowId"
                          class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                        <span (click)="getScoreToFinalConverterIndividual()"
                          *ngIf="editedIndividualScoreId === rowId && onCheckIconView"
                          class="material-icons close p-10 cp fs-20">close</span>
                        <!-- Single condition for reimbursementAddId check -->
                        <span *ngIf="editedIndividualScoreId === rowId && onCheckIconView "
                          (click)="handleReimbursementClick(item.limit,item.reimbursementId,rowId,'')"
                          class="material-icons link p-10 cp fs-20">
                          check
                        </span>


                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="p-10">
            <div class="setUptable-container table-container">

              <!-- Table only visible if limitType === 'Both' -->
              <table class="hover mb-5 reimbursmenttable custom-table rounded-header" *ngIf="selectedReimbursement != null 
                 && wantLimit !== 'no' 
                 && wantLimit !== '' 
                 && limitType === 'Both'">

                <thead class="bg-gray">
                  <tr>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">Band</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">Grade</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">Limit</th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black"></th>
                  </tr>
                </thead>

                <tbody class="bg-white">
                  <ng-container *ngFor="let item of bandListData; let i = index">
                    <tr *ngFor="let gradeItem of item?.grades; let rowId = index">

                      <!-- Band column -->
                      <td *ngIf="rowId === 0" [attr.rowspan]="item?.grades.length">
                        <span>{{ item.band }}</span>
                      </td>

                      <!-- Grade column -->
                      <td>{{ gradeItem.grade }}</td>

                      <!-- Limit column -->
                      <td>
                        <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                          <input [(ngModel)]="gradeItem.limit" type="number"
                            (ngModelChange)="IndividualTotalWeightage(item,gradeItem.grade)"
                            (keydown)="preventNegative($event)"
                            [disabled]="editedIndividualScoreId !== (item.band + '-' + gradeItem.grade) && !isFormDisabled"
                            matInput placeholder="Set Limit" class="font_regular">
                        </mat-form-field>
                      </td>

                      <!-- Actions column -->
                      <td>
                        <div class="d-flex">
                          <!-- Edit icon -->
                          <img (click)="onClickIndividualScoreEdit(item.band + '-' + gradeItem.grade)"
                            *ngIf="editedIndividualScoreId !== (item.band + '-' + gradeItem.grade)"
                            class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">

                          <!-- Close icon -->
                          <span (click)="getScoreToFinalConverterIndividual()"
                            *ngIf="editedIndividualScoreId === (item.band + '-' + gradeItem.grade) && onCheckIconView"
                            class="material-icons close p-10 cp fs-20">close</span>

                          <!-- Check icon -->
                          <span
                            *ngIf="editedIndividualScoreId === (item.band + '-' + gradeItem.grade) && onCheckIconView"
                            (click)="handleReimbursementClick(gradeItem.limit,item.reimbursementId,item.band + '-' + gradeItem.grade,gradeItem.check)"
                            class="material-icons link p-10 cp fs-20">
                            check
                          </span>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>






    <!-------------------------------------------------------Employee Login ------------------------------------------------>

    <div class="card employeeTab">
      <div class="card-body">

        <!-- <div> -->
        <div *ngIf="selectedTypeTabName=='Employee Admin'">
          <ion-row class="col-md-reverse">
            <ion-col size="12" size-md>
              <!-- <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                  <mat-icon matPrefix>search</mat-icon>
                  <input matInput type="search" placeholder="Search" [(ngModel)]="searchTaskString"
                    (input)="onSearchTask(searchTaskString)">
                </mat-form-field> -->
            </ion-col>
            <ion-col size="12" size-md="auto">
              <!-- Refresh Icon -->
              <span class="ml-5  fs-20 material-icons btn-reset" style="cursor:pointer;" [class.clicked]="isClicked"
                (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">
                refresh
              </span>
            </ion-col>
            <ion-col size="12" size-md="auto">
              <button type="button" class="add_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                (click)="addKPISPopup(null)">+ New Reimbursement</button>
            </ion-col>
          </ion-row>


          <mat-sidenav-container style="height: 100%;">
            <!-- Main Content with AG Grid -->

            <mat-sidenav-content>
              <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz" [rowData]="tableDataDetails"
                [columnDefs]="taskColumnHeaderInfo" [gridOptions]="gridOptions" [defaultColDef]="defaultColDef"
                (gridReady)="onGridReady($event)" (cellClicked)="onRowClickedForEmployee($event)"
                [pagination]="pagination" [paginationPageSize]="paginationPageSize"
                [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight"
                [localeText]="{ noRowsToShow: 'No Data Found' }">
              </ag-grid-angular>
            </mat-sidenav-content>
            <!-- Right Side Sidenav -->
            <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
              <!-- HEADER -->
              <div class="details-header">
                <h2>Reimbursement Details</h2>
                <button mat-icon-button (click)="closeDetails()">
                  <mat-icon class="close-icon">close</mat-icon>
                </button>
              </div>

              <!-- CONTENT -->
              <div class="details-content" *ngIf="selectedRow">
                <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfo">
                  <mat-card-content>
                    <div class="detail-row">
                      <mat-icon class="detail-icon">trending_flat</mat-icon>
                      <div class="detail-text">

                        <!-- LABEL -->
                        <span class="detail-label">{{ col.headerName }}</span>

                        <!-- STATUS BADGE -->
                        <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                          <span class="status-badge" [ngClass]="{
                                    'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                    'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                    'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                                  }">
                            {{ formatStatus(selectedRow[col.field]) }}
                          </span>
                        </ng-container>

                        <!-- APPROVAL BADGE -->
                        <ng-template #approvalCheck>
                          <ng-container *ngIf="col.headerName === 'Approval'; else actionCheck">
                            <span class="status-badge" [ngClass]="{
                                      'approved': selectedRow[col.field] === 'APPROVED',
                                      'rejected': selectedRow[col.field] === 'REJECTED',
                                      'pending': selectedRow[col.field] === 'PENDING'
                                    }">
                              {{ formatStatus(selectedRow[col.field]) }}
                            </span>
                          </ng-container>
                        </ng-template>

                        <!-- ACTION BUTTONS with condition -->
                        <ng-template #actionCheck>
                          <ng-container *ngIf="col.headerName === 'Action'; else normalContent">
                            <div class="d-flex align-items-center"
                              *ngIf="(selectedRow.approvedByManager !== 'APPROVED' && selectedRow.approvedByManager !== 'REJECTED') 
                                       && (selectedRow.approvedStatus !== 'APPROVED' && selectedRow.approvedStatus !== 'REJECTED')">

                              <!-- Edit -->
                              <mat-icon class="cp mr-10" style="color:#ff9800;cursor:pointer; width: 31px;"
                                (click)="addKPISPopup(selectedRow)">edit</mat-icon>

                              <!-- Delete -->
                              <mat-icon class="cp" style="color:#e53935;cursor:pointer;width: 31px;"
                                (click)="deleteEmployee(selectedRow.reimbursementApplicationId)">delete</mat-icon>
                            </div>
                          </ng-container>
                        </ng-template>

                        <!-- NORMAL DATA / DOCUMENT -->
                        <ng-template #normalContent>
                          <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                            <ng-container *ngIf="selectedRow[col.field]; else noFile">
                              <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                                style="cursor:pointer"
                                (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                            </ng-container>
                            <ng-template #noFile>
                              <span></span>
                            </ng-template>
                          </ng-container>

                          <ng-template #textValue>
                            <span>
                              {{ (col.field === 'date' || col.field === 'dateOfExpense')
                              ? formatDate(selectedRow[col.field])
                              : selectedRow[col.field] || ''}}
                            </span>
                          </ng-template>
                        </ng-template>

                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>


            </mat-sidenav>
          </mat-sidenav-container>

        </div>
        <!-- </div> -->
      </div>
    </div>

    <!-------------------------------------------------------Manager Login ------------------------------------------------>

    <div class="card  employeeTab">

      <div class="p-10" *ngIf="selectedTypeTabName=='Manager'">
        <div class="mb-10">

          <ion-col size="9">

          </ion-col>
          <span class="fs-20 material-icons btn-reset cursor-pointer" [class.clicked]="isClicked"
            (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">
            refresh
          </span>
          <!-- </ion-col> -->
        </div>

        <!-- {{allTeamReimbursement |json}} -->
        <mat-sidenav-container style="height: 100%;">
          <!-- Main Content with AG Grid -->
          <mat-sidenav-content>
            <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
              [rowData]="allTeamReimbursement" [columnDefs]="taskColumnHeaderInfoForManager" [gridOptions]="gridOptions"
              [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
              (cellClicked)="onCelledClicked($event)" [pagination]="pagination"
              [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector"
              [detailRowAutoHeight]="detailRowAutoHeight" (cellValueChanged)="onCellValueChanged($event)"
              [localeText]="{ noRowsToShow: 'No Data Found' }">
            </ag-grid-angular>
          </mat-sidenav-content>
          <!-- Right Side Sidenav -->
          <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
            <!-- HEADER -->
            <div class="details-header">
              <h2>Reimbursement Details</h2>
              <button mat-icon-button (click)="closeDetails()">
                <mat-icon class="close-icon">close</mat-icon>
              </button>
            </div>
            <!-- CONTENT -->
            <div class="details-content" *ngIf="selectedRow">
              <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfoForManager">
                <mat-card-content>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">trending_flat</mat-icon>
                    <div class="detail-text">

                      <!-- LABEL -->
                      <span class="detail-label">{{ col.headerName }}</span>

                      <!-- STATUS BADGE -->
                      <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                        <span class="status-badge" [ngClass]="{
                                'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>

                      <!-- APPROVAL DROPDOWN -->
                      <ng-template #approvalCheck>
                        <ng-container *ngIf="col.headerName === 'Approval'; else managerCheck">
                          <mat-form-field appearance="outline" class="w-100 mw-sm-250 mat-height40 approval-select">
                            <mat-select [(ngModel)]="selectedRow[col.field]" placeholder="PENDING"
                              (ngModelChange)="onApprovalChangedDetail($event, selectedRow)"
                              [disabled]="selectedRow[col.field] === 'APPROVED' || selectedRow[col.field] === 'REJECTED'">

                              <!-- Approved -->
                              <mat-option value="APPROVED" class="approved-option">
                                Approve
                              </mat-option>

                              <!-- Rejected -->
                              <mat-option value="REJECTED" class="rejected-option">
                                Reject
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>

                      <!-- MANAGER COMMENT (editable in detail view) -->
                      <ng-template #managerCheck>
                        <ng-container *ngIf="col.headerName === 'Manager Comment'; else normalContent">
                          <mat-form-field appearance="outline" class="w-full max-w-lg">
                            <textarea matInput [(ngModel)]="selectedRow[col.field]"
                              [readonly]="selectedRow['approvedByManager'] === 'APPROVED' || selectedRow['approvedByManager'] === 'REJECTED'"
                              placeholder="Write your comment..." rows="3" (blur)="onManagerCommentChanged(selectedRow)"
                              maxlength="250" class="resize-none">
                          </textarea>
                            <mat-hint align="end">{{ selectedRow[col.field]?.length || 0 }}/250</mat-hint>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>


                      <!-- NORMAL DATA / DOCUMENT -->
                      <ng-template #normalContent>
                        <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                          <ng-container *ngIf="selectedRow[col.field]; else noFile">
                            <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                              style="cursor:pointer"
                              (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                          </ng-container>
                          <ng-template #noFile>
                            <span></span>
                          </ng-template>
                        </ng-container>

                        <ng-template #textValue>
                          <span>
                            {{ (col.field === 'date' || col.field === 'dateOfExpense')
                            ? formatDate(selectedRow[col.field])
                            : selectedRow[col.field] || '' }}
                          </span>
                        </ng-template>
                      </ng-template>

                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

          </mat-sidenav>
        </mat-sidenav-container>

      </div>
    </div>




    <!-------------------------------------------------------HR Admin Login ------------------------------------------------>


    <div class="card  employeeTab">

      <div class="p-10" *ngIf="selectedTypeTabName=='HrAdmin'">
        <div class="mb-10">

          <ion-col size="9">

          </ion-col>
          <span class="fs-20 material-icons btn-reset cursor-pointer" [class.clicked]="isClicked"
            (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">
            refresh
          </span>
          <!-- </ion-col> -->
        </div>


        <mat-sidenav-container style="height: 100%;">
          <!-- Main Content with AG Grid -->
          <mat-sidenav-content>

            <!-- <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
              [rowData]="allTeamMemberReimbursementApprove" [columnDefs]="taskColumnHeaderInfoForHrAdmin" [gridOptions]="gridOptions"
              [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
              (cellClicked)="onCelledClicked($event)" [pagination]="pagination"
              [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector"
              [detailRowAutoHeight]="detailRowAutoHeight" (cellValueChanged)="onCellValueChanged($event)"
              [localeText]="{ noRowsToShow: 'No Data Found' }">
            </ag-grid-angular> -->
            <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
              [rowData]="allTeamMemberReimbursementApprove" [columnDefs]="taskColumnHeaderInfoForHrAdmin"
              [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
              [pagination]="pagination" [paginationPageSize]="paginationPageSize"
              [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight"
              (cellValueChanged)="onCellValueChanged($event)" [localeText]="{ noRowsToShow: 'No Data Found' }">
            </ag-grid-angular>
          </mat-sidenav-content>
          <!-- Right Side Sidenav -->
          <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
            <!-- HEADER -->
            <div class="details-header">
              <h2>Reimbursement Details</h2>
              <button mat-icon-button (click)="closeDetails()">
                <mat-icon class="close-icon">close</mat-icon>
              </button>
            </div>
            <!-- CONTENT -->
            <div class="details-content" *ngIf="selectedRow">
              <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfoForHrAdmin">
                <mat-card-content>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">trending_flat</mat-icon>
                    <div class="detail-text">

                      <!-- LABEL -->
                      <span class="detail-label">{{ col.headerName }}</span>

                      <!-- STATUS BADGE -->
                      <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                        <span class="status-badge" [ngClass]="{
                                'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>

                      <!-- APPROVAL DROPDOWN -->
                      <ng-template #approvalCheck>
                        <ng-container *ngIf="col.headerName === 'Approval'">
                          <mat-form-field appearance="outline" class="w-100 mw-sm-250 mat-height40 approval-select">
                            <mat-select [(ngModel)]="selectedRow[col.field]" placeholder="PENDING"
                              (ngModelChange)=" onApprovalChangedDetailForHrAdmin($event, selectedRow)"
                              [disabled]="selectedRow[col.field] === 'APPROVED' || selectedRow[col.field] === 'REJECTED'">

                              <!-- Approved -->
                              <mat-option value="APPROVED" class="approved-option">
                                Approve
                              </mat-option>

                              <!-- Rejected -->
                              <mat-option value="REJECTED" class="rejected-option">
                                Reject
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>


                      <!-- NORMAL DATA / DOCUMENT -->
                      <ng-template #normalContent>
                        <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                          <ng-container *ngIf="selectedRow[col.field]; else noFile">
                            <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                              style="cursor:pointer"
                              (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                          </ng-container>
                          <ng-template #noFile>
                            <span></span>
                          </ng-template>
                        </ng-container>

                        <ng-template #textValue>
                          <span>
                            {{ (col.field === 'date' || col.field === 'dateOfExpense')
                            ? formatDate(selectedRow[col.field])
                            : selectedRow[col.field] || '' }}
                          </span>
                        </ng-template>
                      </ng-template>

                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

          </mat-sidenav>
        </mat-sidenav-container>

      </div>
    </div>




    <!-------------------------------------------------------Finance Login ------------------------------------------------>

    <div class="card  employeeTab">

      <div *ngIf="selectedTypeTabName=='Finance'">


        <ion-row class="ion-align-items-end">
          <!-- Finance Dropdown -->
          <ion-col size="12" size-md="2" *ngIf="isLoginFinanceEnable">

            <div class="font_semibold fs-16 fs_14ForMobile mb-5">
              Select Finance<span class="red-cl">&nbsp;*</span>
            </div>
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select class="centered-label" name="reimbursementSelect" [(ngModel)]="financeIdForEmployee"
                (selectionChange)="getFinaceForReimbursement($event.value)">
                <mat-option [value]="-1">Select All Finance</mat-option>
                <mat-option *ngFor="let item of fitergetAllFinanceUserDD" [value]="item.id">
                  {{ item.firstName }} {{ item.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>

          <!-- Right Side Actions -->
          <ion-col size="12" [attr.size-md]="isLoginFinanceEnable ? 10 : 12" class="ion-text-md-end">

            <!-- Refresh Icon -->
            <span class="ml-5 mt-10 fs-20 material-icons btn-reset" style="cursor:pointer;" [class.clicked]="isClicked"
              (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">
              refresh
            </span>

          </ion-col>
        </ion-row>


        <mat-sidenav-container style="height: 100%;" *ngIf="loggedInUserRole =='HR Admin'">
          <!-- Main Content with AG Grid -->
          <mat-sidenav-content>
            <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
              [rowData]="allTeamMemberReimbursementApprove" [columnDefs]="taskColumnHeaderInfoForFinanceHRAdmin"
              [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
              (rowClicked)="onRowClicked($event)" (cellClicked)="onCelledClicked($event)" [pagination]="pagination"
              [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector"
              [detailRowAutoHeight]="detailRowAutoHeight" (cellValueChanged)="onCellValueChanged($event)"
              [localeText]="{ noRowsToShow: 'No Data Found' }">
            </ag-grid-angular>

          </mat-sidenav-content>
          <!-- Right Side Sidenav -->
          <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
            <!-- HEADER -->
            <div class="details-header">
              <h2>Reimbursement Details</h2>
              <button mat-icon-button (click)="closeDetails()">
                <mat-icon class="close-icon">close</mat-icon>
              </button>
            </div>

            <!-- CONTENT -->
            <div class="details-content" *ngIf="selectedRow">
              <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfoForFinanceHRAdmin">
                <mat-card-content>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">trending_flat</mat-icon>
                    <div class="detail-text">

                      <!-- LABEL -->
                      <span class="detail-label">{{ col.headerName }}</span>

                      <!-- STATUS BADGE -->
                      <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                        <span class="status-badge" [ngClass]="{
                                'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>

                      <!-- APPROVAL BADGE -->
                      <ng-template #approvalCheck>
                        <ng-container *ngIf="col.headerName === 'Approval'; else normalContent">
                          <span class="status-badge" [ngClass]="{
                                  'approved': selectedRow[col.field] === 'APPROVED',
                                  'rejected': selectedRow[col.field] === 'REJECTED',
                                  'pending': selectedRow[col.field] === 'PENDING'
                                }">
                            {{ formatStatus(selectedRow[col.field]) }}
                          </span>
                        </ng-container>
                      </ng-template>

                      <!-- NORMAL DATA / DOCUMENT -->
                      <ng-template #normalContent>
                        <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                          <ng-container *ngIf="selectedRow[col.field]; else noFile">
                            <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                              style="cursor:pointer"
                              (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                          </ng-container>
                          <ng-template #noFile>
                            <span></span>
                          </ng-template>
                        </ng-container>


                        <ng-template #textValue>
                          <span>
                            {{ (col.field === 'date' || col.field === 'dateOfExpense')
                            ? formatDate(selectedRow[col.field])
                            : selectedRow[col.field] || selectedRow[col.field]}}
                          </span>
                        </ng-template>
                      </ng-template>

                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-sidenav>
        </mat-sidenav-container>
        <!-- {{allTeamMemberReimbursementApprove |json}} -->
        <mat-sidenav-container style="height: 100%;" *ngIf="loggedInUserRole !='HR Admin'">
          <!-- Main Content with AG Grid -->
          <mat-sidenav-content>
            <!-- // For Finance login -->
            <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz"
              [rowData]="allTeamMemberReimbursementApprove" [columnDefs]="taskColumnHeaderInfoForFinanse"
              [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
              (rowClicked)="onRowClicked($event)" (cellClicked)="onCelledFinanceClicked($event)"
              [pagination]="pagination" [paginationPageSize]="paginationPageSize"
              [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight"
              (cellValueChanged)="onCellValueChanged($event)" [localeText]="{ noRowsToShow: 'No Data Found' }">
            </ag-grid-angular>
          </mat-sidenav-content>
          <!-- Right Side Sidenav -->
          <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
            <!-- HEADER -->
            <div class="details-header">
              <h2>Reimbursement Details</h2>
              <button mat-icon-button (click)="closeDetails()">
                <mat-icon class="close-icon">close</mat-icon>
              </button>
            </div>
            <!-- CONTENT -->
            <div class="details-content" *ngIf="selectedRow">
              <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfoForFinanse">
                <mat-card-content>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">trending_flat</mat-icon>
                    <div class="detail-text">

                      <!-- LABEL -->
                      <span class="detail-label">{{ col.headerName }}</span>

                      <!-- STATUS BADGE -->
                      <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                        <span class="status-badge" [ngClass]="{
                                'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>

                      <!-- APPROVAL DROPDOWN -->
                      <ng-template #approvalCheck>
                        <ng-container *ngIf="col.headerName === 'Approval'; else managerCheck">
                          <mat-form-field appearance="outline" class="w-100 mw-sm-250 mat-height40 approval-select">
                            <mat-select [(ngModel)]="selectedRow[col.field]" placeholder="PENDING"
                              (ngModelChange)="onApprovalChangedDetailForFinance($event, selectedRow)"
                              [disabled]="!selectedRow.assignedAmount || selectedRow[col.field] === 'APPROVED' || selectedRow[col.field] === 'REJECTED'">

                              <!-- Approved -->
                              <mat-option value="APPROVED" class="approved-option">Approve</mat-option>

                              <!-- Rejected -->
                              <mat-option value="REJECTED" class="rejected-option">Reject</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>


                      <!-- FINANCE COMMENT -->
                      <ng-template #managerCheck>
                        <ng-container *ngIf="col.headerName === 'Finance Comment'; else actualAmountCheck">
                          <mat-form-field appearance="outline" class="w-full max-w-lg">
                            <textarea matInput [(ngModel)]="selectedRow[col.field]"
                              [readonly]="selectedRow['financeStatus'] === 'APPROVED' || selectedRow['financeStatus'] === 'REJECTED'"
                              placeholder="Write your comment..." rows="3" (blur)="onFinanceCommentChanged(selectedRow)"
                              maxlength="250" class="resize-none">
                            </textarea>
                            <mat-hint align="end">{{ selectedRow[col.field]?.length || 0 }}/250</mat-hint>
                          </mat-form-field>
                        </ng-container>
                      </ng-template>

                      <!-- ACTUAL AMOUNT BY FINANCE (INPUT BOX) -->
                      <ng-template #actualAmountCheck>
                        <ng-container *ngIf="col.headerName === 'Actual Amount by Finance'; else normalContent">
                          <mat-form-field appearance="outline" class="w-100 mw-sm-250">
                            <input matInput type="number" [(ngModel)]="selectedRow[col.field]"
                              [readonly]="selectedRow['financeStatus'] === 'APPROVED' || selectedRow['financeStatus'] === 'REJECTED'"
                              placeholder="Enter amount" (blur)="onActualAmountChangedDetail(selectedRow)" />
                          </mat-form-field>
                        </ng-container>
                      </ng-template>

                      <!-- NORMAL DATA / DOCUMENT -->
                      <ng-template #normalContent>
                        <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                          <ng-container *ngIf="selectedRow[col.field]; else noFile">
                            <img src="assets/icon/yellowdownload.png" alt="download" width="18" height="18"
                              style="cursor:pointer"
                              (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))" />
                          </ng-container>
                          <ng-template #noFile>
                            <span></span>
                          </ng-template>
                        </ng-container>

                        <ng-template #textValue>
                          <span>
                            {{ (col.field === 'date' || col.field === 'dateOfExpense')
                            ? formatDate(selectedRow[col.field])
                            : selectedRow[col.field] || '' }}
                          </span>
                        </ng-template>
                      </ng-template>

                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

            </div>

          </mat-sidenav>
        </mat-sidenav-container>


      </div>
    </div>

    <div class="card  employeeTab">

      <div class="p-10" *ngIf="selectedTypeTabName=='Reports'">
        <app-expense-report></app-expense-report>
      </div>
    </div>

    <div class="p-10" *ngIf="selectedTypeTabName=='Dashboard' && !router.url.includes('Setup')">
      <app-expense-dashboard></app-expense-dashboard>
    </div>

  </div>
</ion-content>